var _path, _path2, _path3, _path4, _path5, _path6;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgWave(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 60,
    height: 60,
    viewBox: "0 0 60 60",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M17.8619 16.9631C16.995 15.4476 15.0636 14.9219 13.5481 15.7889C12.0326 16.6559 11.5069 18.5873 12.3739 20.1027C12.5129 20.3457 12.6835 20.5691 12.8813 20.7671L23.2063 34.2859L25.6131 37.319L18.5486 28.0693C17.6817 26.5538 15.7503 26.0281 14.2348 26.8951C12.7193 27.7621 12.1936 29.6935 13.0606 31.209C13.1996 31.4519 13.3702 31.6753 13.568 31.8734L20.6324 41.1229L26.2466 48.1949C31.1412 53.8112 39.2416 53.5046 44.8566 48.6112C48.0837 45.7745 50.1591 41.8533 50.6899 37.5896C51.0353 33.8001 51.4124 23.8906 51.4124 23.8906C51.2489 21.5621 48.6053 19.8408 48.2647 21.0433L43.8831 29.7793L40.8698 25.9989L43.8831 29.7793L40.8698 25.9989L28.8145 10.592C27.9476 9.07657 26.0162 8.55085 24.5007 9.41786C22.9852 10.2849 22.4595 12.2162 23.3265 13.7317C23.4654 13.9747 23.6361 14.1981 23.8339 14.396L27.6378 19.3767L33.3887 26.9688L21.3746 11.1398C20.5077 9.62431 18.5763 9.09859 17.0608 9.9656C15.5453 10.8326 15.0196 12.764 15.8865 14.2794C16.0255 14.5224 16.1961 14.7458 16.3939 14.9438L29.5294 31.9675",
    fill: "#FFC938"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M17.8619 16.9631C16.995 15.4476 15.0636 14.9219 13.5481 15.7889C12.0326 16.6559 11.5069 18.5873 12.3739 20.1027C12.5129 20.3457 12.6835 20.5691 12.8813 20.7671L23.2063 34.2859L25.6131 37.319L18.5486 28.0693C17.6817 26.5538 15.7503 26.0281 14.2348 26.8951C12.7193 27.7621 12.1936 29.6935 13.0606 31.209C13.1996 31.4519 13.3702 31.6753 13.568 31.8734L20.6324 41.1229L26.2466 48.1949C31.1412 53.8112 39.2416 53.5046 44.8566 48.6112C48.0837 45.7745 50.1591 41.8533 50.6899 37.5896C51.0353 33.8001 51.4124 23.8906 51.4124 23.8906C51.2489 21.5621 48.6053 19.8408 48.2647 21.0433L43.8832 29.7793L40.8698 25.9989L28.8145 10.592C27.9476 9.07657 26.0162 8.55085 24.5007 9.41786C22.9852 10.2849 22.4595 12.2162 23.3265 13.7317C23.4654 13.9747 23.6361 14.1981 23.8339 14.396L27.6378 19.3767L33.3887 26.9688L21.3746 11.1398C20.5077 9.62431 18.5763 9.09859 17.0608 9.9656C15.5453 10.8326 15.0196 12.764 15.8865 14.2794C16.0255 14.5224 16.1961 14.7458 16.3939 14.9438L29.5294 31.9675",
    stroke: "black",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M11.6082 38.1201C11.6082 40.4177 13.1722 42.2768 15.1051 42.2768",
    stroke: "black",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M7.47974 37.7305C7.47974 42.7405 10.8903 46.7946 15.1051 46.7946",
    stroke: "black",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M41.6806 18.7505C41.6806 16.4528 40.1165 14.5938 38.1836 14.5938",
    stroke: "black",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M45.809 19.1403C45.809 14.1303 42.3984 10.0762 38.1836 10.0762",
    stroke: "black",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgWave);
export default __webpack_public_path__ + "static/media/wave.bbf40777f87b6b8f6929b2b8049979ea.svg";
export { ForwardRef as ReactComponent };